import { createFileRoute, redirect } from "@tanstack/react-router";

// Transactional emails use this URL. Keep already-issued links working while
// sharing the existing single-use-token verification screen.
export const Route = createFileRoute("/auth/verify")({
  validateSearch: (raw): { token?: string } => ({
    token: typeof raw.token === "string" ? raw.token : undefined,
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/auth/verify-email",
      search,
      replace: true,
    });
  },
});
